import type { GameMode } from './protocol';

const NN = ' ';

/** Paroles de la comptine, en lignes de mots (affichage karaoké). */
export function chantLines(mode: GameMode): string[][] {
  const verb = mode === 'laugh' ? 'rira' : 'clignera';
  return [
    'Je te tiens, tu me tiens'.split(' '),
    'par la barbichette,'.split(' '),
    `le premier de nous deux qui ${verb}`.split(' '),
    ['aura', 'une', `tapette${NN}!`],
  ];
}

export interface ChantProgress {
  readonly line: number;
  readonly word: number;
  readonly done: boolean;
}

/** Mot à mettre en valeur à l'instant `elapsedMs` d'une comptine de `totalMs`. */
export function chantProgress(
  lines: readonly (readonly string[])[],
  elapsedMs: number,
  totalMs: number,
): ChantProgress {
  const words = lines.flatMap((l, line) => l.map((_, word) => ({ line, word })));
  if (!(totalMs > 0) || elapsedMs >= totalMs || words.length === 0) {
    const last = words.at(-1) ?? { line: 0, word: 0 };
    return { ...last, done: true };
  }
  const index = Math.min(
    words.length - 1,
    Math.floor((Math.max(0, elapsedMs) / totalMs) * words.length),
  );
  const current = words[index] ?? { line: 0, word: 0 };
  return { ...current, done: false };
}

/** Chifoumi : le « MI ! » n'est pas chanté ici, il ouvre la phase du geste. */
export const CHIFOUMI_CHANT: readonly (readonly string[])[] = [['Chi…', 'fou…']];
